/**
 * Util functions for iFrame-title functionality
 * @module frames/IFrameTitleUtils
 */

/**
 * Attaches listener to DOMContentLoaded and calls sendDocumentTitleToParent on event trigger
 */
export const attachOnReadySendTitleToParent = () => {
    if (document.readyState === 'complete') {
        sendDocumentTitleToParent();
    } else {
        document.addEventListener('DOMContentLoaded', sendDocumentTitleToParent);
    }
};

/**
 * Sends own document title via postmessage to parent window.
 * @param {string} title - The title to send. If not provided, document.title will be used.
 */
export const sendDocumentTitleToParent = (title) => {
    if (window.self !== window.top) {
        const messageData = { messageName: 'setIFrameTitleMessage', iFrameTitle: title || document.title };

        window.parent.postMessage(JSON.stringify(messageData), '*');
    }
};

/**
 * Attaches a listener that listens for postMessages with messagename 'setIFrameTitle'
 * @param iFrameElementId the iframe that it will set the title on, and also the only iframe it will accept postmessage from
 */
export const attachSetIFrameTitlePostMessageEventListener = (iFrameElementId) => {
    window.addEventListener('message', function (event) {
        if (!event.data) {
            return;
        }

        const iFrameElement = document.getElementById(iFrameElementId);

        // @ts-ignore
        if (event.source !== iFrameElement.contentWindow) {
            return;
        }

        try {
            const jsonData = JSON.parse(event.data);

            if (!jsonData.messageName || jsonData.messageName !== 'setIFrameTitleMessage') {
                return;
            }

            setTitleToIFrame(jsonData.iFrameTitle, iFrameElement);
        } catch (err) {
        }
    }, false);
};

/**
 * Sets title to iFrame
 * @param iFrameTitle
 * @param iFrameElement
 */
function setTitleToIFrame(iFrameTitle, iFrameElement) {
    if (!iFrameElement) {
        return;
    }

    if (iFrameTitle) {
        iFrameElement.setAttribute('title', iFrameTitle);
    } else {
        iFrameElement.removeAttribute('title');
    }
}
